import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Switch } from '../ui/switch';

const sel = 'w-full h-10 rounded-md bg-[#0A0A0A] border border-[#262626] text-white text-sm px-2';

// iter317 — Add / Edit a Service Type: name, Trade → Division (filtered), behavior flags, active.
export const ServiceTypeEditDialog = ({ open, onOpenChange, initial, trades, divisions, onSave }) => {
  const [f, setF] = useState(initial);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) setF(initial); }, [open, initial]);
  if (!f) return null;
  const divs = divisions.filter((d) => d.trade_id === f.department_id && (d.active || d.id === f.division_id));
  const setTrade = (tid) => setF({ ...f, department_id: tid, division_id: divisions.some((d) => d.id === f.division_id && d.trade_id === tid) ? f.division_id : '' });
  const flag = (k, label, tid) => (
    <label className="flex items-center justify-between gap-2 text-sm text-white rounded-md border border-[#262626] px-3 py-2">
      {label}
      <Switch data-testid={tid} checked={!!f[k]} onCheckedChange={(v) => setF({ ...f, [k]: v })} className="data-[state=checked]:bg-[#D4AF37]" />
    </label>
  );
  const submit = async () => {
    if (!f.name?.trim()) return;
    setSaving(true);
    await onSave({ ...f, name: f.name.trim() });
    setSaving(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="st-edit-dialog" className="bg-[#141414] border-[#262626] text-white max-w-lg">
        <DialogHeader>
          <DialogTitle>{f.id ? 'Edit Service Type' : 'Add Service Type'}</DialogTitle>
          <DialogDescription className="text-[#A3A3A3]">Trade → Division → Service Type. Leave Trade/Division blank to keep it Unassigned.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <Input data-testid="st-edit-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="e.g. Tankless Water Heater" className="bg-[#0A0A0A] border-[#262626] text-white" />
          <div className="grid grid-cols-2 gap-2">
            <select data-testid="st-edit-trade" value={f.department_id || ''} onChange={(e) => setTrade(e.target.value)} className={sel}>
              <option value="">Trade: Unassigned</option>
              {trades.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
            <select data-testid="st-edit-division" value={f.division_id || ''} disabled={!f.department_id} onChange={(e) => setF({ ...f, division_id: e.target.value })} className={`${sel} disabled:opacity-50`}>
              <option value="">Division: Unassigned</option>
              {divs.map((d) => <option key={d.id} value={d.id}>{d.name}{d.active ? '' : ' (inactive)'}</option>)}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-2">
            {flag('customer_required', 'Customer Required', 'st-edit-cust-req')}
            {flag('revenue_outcome_required', 'Revenue Outcome', 'st-edit-rev-req')}
            {flag('track_time', 'Track Time', 'st-edit-track')}
            {flag('active', 'Active', 'st-edit-active')}
          </div>
          <Button data-testid="st-edit-save" disabled={saving || !f.name?.trim()} onClick={submit} className="w-full bg-[#D4AF37] text-[#0A0A0A] hover:bg-[#F3E5AB] font-bold">{saving ? 'Saving…' : (f.id ? 'Save Changes' : 'Add Service Type')}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ServiceTypeEditDialog;
